import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import {
  getOptions,
  doSearch,
} from "../../../containers/Search/Search.actions";
import { Select, Button, Alert } from "antd";
import "./SearchBox.scss";
const { Option } = Select;

export default function SearchBox() {
  const [searchValue, updateSearch] = useState(undefined);
  const [loading, setLoading] = useState(false);
  const [options, updateOptions] = useState([]);
  const [redirect, doRedirect] = useState("");

  useEffect(() => {
    if (searchValue) {
      handleOptions(searchValue);
    }
  }, [searchValue]);

  const handleSearch = (value) => {
    if (value && value.length > 2) {
      updateSearch(value);
    }
  };

  const handleOptions = async (searchValue) => {
    try {
      setLoading(true);
      const results = await getOptions(searchValue);
      const items = results.map((o, i) => (
        <Option
          key={`${o.desc}-${i}`}
          className="SearchBox__option"
          value={o.value}
          type={o.desc}
          title={o.value}
        >
          <span className="title">{o.desc}</span>
          <span>{o.value}</span>
        </Option>
      ));
      updateOptions(items);
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const handleChange = async (value, data) => {
    const searchUrl = await doSearch(data);
    doRedirect(searchUrl);
    doRedirect("");
    updateOptions([]);
    updateSearch(undefined);
  };

  if (redirect.length) {
    return <Redirect to={redirect} />;
  } else {
    return (
      <>
        <div className="SearchBox">
          <div className="container">
            <Select
              showSearch
              value={searchValue}
              placeholder="Search by Address/TXn Hash/Token/Contract"
              defaultActiveFirstOption={false}
              showArrow={false}
              filterOption={false}
              onSearch={(value) => handleSearch(value)}
              onSelect={(label, optionData) => handleChange(label, optionData)}
              notFoundContent={null}
              size="large"
              style={{ width: "100%" }}
              optionLabelProp="label"
            >
              {options}
            </Select>
            <Button
              type="primary"
              size="large"
              loading={loading}
              onClick={() => handleChange(null, searchValue)}
            >
              Search
            </Button>
          </div>
        </div>
        <div className="WarningBox">
          <Alert
            message="You are viewing the TRON explorer"
            description={
              <span>
                On the 15th of July 2021 Centric migrated to Binance Smart Chain (BSC).{" "}
                <a
                  href="https://explorer.centric.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View Centric's BSC explorer here.
                </a>
              </span>
            }
            type="warning"
            showIcon
          />
        </div>
      </>
    );
  }
}
